import { render, staticRenderFns } from "./Select2Detail.vue?vue&type=template&id=daeac1f0"
import script from "./Select2Detail.vue?vue&type=script&lang=js"
export * from "./Select2Detail.vue?vue&type=script&lang=js"
import style0 from "./Select2Detail.vue?vue&type=style&index=0&id=daeac1f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports